import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
    interface Palette {
        codeBlock: {
            background: string;
            text: string;
            comment: string;
        };
    }
    interface PaletteOptions {
        codeBlock?: {
            background?: string;
            text?: string;
            comment?: string;
        };
    }
}

const LightTheme = createTheme({
    palette: {
        mode: 'light',
        background: {
            default: '#f3e9f3', // --dashboardBackColor
            paper: '#f9f0f9',   // --backColor     

        },
        text: {
            primary: '#6c5b7b', // --textColor
            secondary: '#464646', // --buttonTextColor
        },
        codeBlock: {
            background: '#2d2d2d',
            text: '#ffffff',
            comment: '#6a9955',
        },

        primary: {
            main: '#c7b9d9', // your --headerBackColor
        },

    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#6c5b7b', // --headerBackColor
                    color: '#ffffff',
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f3e9f3', // --backColorOdd
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: '#464646', // --buttonTextColor
                    '&.Mui-selected': {
                        color: '#6c5b7b', // --headerBackColor
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f9f0f9', // --inputBackColor
                    '&:hover': {
                        backgroundColor: '#f3e9f3', // --inputHoverBackColor
                    },
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                            borderColor: '#b79dc9', // Darker focus border for better visibility
                        },
                    },
                    '& .MuiInputBase-input': {
                        color: '#6c5b7b', // --textColor
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#ddd',
                    },
                    '& input:-webkit-autofill': {
                        backgroundColor: '#f9f0f9 !important',
                        color: '#6c5b7b !important',
                        boxShadow: '0 0 0 100px #f9f0f9 inset !important',
                        borderColor: '#ddd !important',
                    },
                    '& input:-webkit-autofill:focus': {
                        borderColor: '#f3e1f3 !important',
                        boxShadow: '0 0 0 100px #f9f0f9 inset !important',
                    },
                    '& .MuiInputLabel-root': {
                        color: '#6c5b7b', // Match --textColor
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f3e9f3', // --dashboardBackColor
                    border: '2px solid #c7b9d9', // --buttonBackColor
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    '&:hover': {
                        border: '2px solid #b9a7cf', // --buttonbackColorOdd
                        boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.15)',
                    },
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '16px',
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#f9f0f9', // --inputBackColor or use backColor
                    color: '#464646', // --buttonTextColor
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#f3e9f3', // --inputHoverBackColor
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#f3e1f3', // --inputFocusBackColor
                        color: '#6c5b7b', // --textColor
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: '#e9d4ed',
                    },
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f9f0f9', // Optional: override in case menu uses List
                },
            },
        },
    },
});

export default LightTheme;